import {
  Cookies,
} from '@resy/ui-kitchen';
import {
  CONTEXT, CATEGORY, RESYCREDIT_GOLD_URL, RESYCREDIT_DELTA_RESERVE_URL,
  RESYCREDIT_DELTA_PLATINUM_URL, CARD_TYPES, RESYCREDIT_AMEX_PLATINUM_URL,
} from './constants';

import {
  CMT_COOKIE_NAME,
  GOLD_CARD,
} from '../AmexMarketingUtils/constants';

import { getKeyByValue } from '../AmexMarketingUtils/AmexUtils';

export const handleTaggingWithProps = (eventName, Analytics, extraParams) => {
  let eventAssetValue = null;
  if (extraParams) {
    const { tab_item: tabItem, action_name: actionName, item_name: itemName } = extraParams;

    if (tabItem)eventAssetValue = `Action Name : ${actionName} > Tab Item : ${tabItem} `;
    else if (itemName)eventAssetValue = `Action Name : ${actionName} > Item Name : ${itemName} `;
    else if (actionName)eventAssetValue = `Action Name : ${actionName} `;
  }
  const params = {
    context: CONTEXT,
    category: CATEGORY,
    ...(extraParams || {}),
    ...eventAssetValue && { eventAsset: eventAssetValue },
  };
  Analytics.event(eventName, params);
};

export const getCardTypesArr = (amexCardTypes = {}) => Object.values(amexCardTypes);

const getCardTypeValue = (userData, amexCardTypes) => {
  const cardTypeValue = 'ALL';
  const amexCardTypesArr = getCardTypesArr(amexCardTypes);
  const userAmexCardTypes = userData?.amex_card_types || [];
  const setUserAmexCardTypes = new Set(userAmexCardTypes);
  for (let i = 0; i < amexCardTypesArr.length; i++) {
    if (amexCardTypesArr[i] instanceof Array) {
      const hasCommonValue = amexCardTypesArr[i].some((item) => setUserAmexCardTypes.has(item));
      if (hasCommonValue) {
        return getKeyByValue(amexCardTypes, amexCardTypesArr[i]);
      }
    } else {
      for (let j = 0; j < userAmexCardTypes.length; j++) {
        if (amexCardTypesArr[i] === userAmexCardTypes[j]) {
          return getKeyByValue(amexCardTypes, amexCardTypesArr[i]);
        }
      }
    }
  }
  return cardTypeValue;
};

export const isUserCardCreditSpecific = (userData, amexCardTypes) => getCardTypeValue(userData, amexCardTypes) !== 'ALL';

export const getCardTypeWithUrl = (locationPath) => {
  const urlPathArr = [RESYCREDIT_GOLD_URL,
    RESYCREDIT_DELTA_RESERVE_URL,
    RESYCREDIT_DELTA_PLATINUM_URL,
    RESYCREDIT_AMEX_PLATINUM_URL];
  const pathArr = locationPath.split('/');
  let cardTypeValue = 'ALL';

  if (pathArr.length === 3) {
    if (urlPathArr.includes(locationPath)) {
      if (locationPath === RESYCREDIT_GOLD_URL) {
        cardTypeValue = CARD_TYPES.GOLD;
      } if (locationPath === RESYCREDIT_DELTA_RESERVE_URL) {
        cardTypeValue = CARD_TYPES.DELTARESERVE;
      } if (locationPath === RESYCREDIT_DELTA_PLATINUM_URL) {
        cardTypeValue = CARD_TYPES.DELTAPLATINUM;
      } if (locationPath === RESYCREDIT_AMEX_PLATINUM_URL) {
        cardTypeValue = CARD_TYPES.AMEXPLATINUM;
      }
    }
  }

  return cardTypeValue;
};

export const getCardType = (locationPath, userData, amexCardTypes) => {
  const pathArr = locationPath.split('/');
  let cardTypeValue = 'ALL';

  if (pathArr.length === 3) {
    cardTypeValue = getCardTypeWithUrl(locationPath);
  } else {
    cardTypeValue = getCardTypeValue(userData, amexCardTypes);
    if (cardTypeValue === 'ALL' && Cookies.get(CMT_COOKIE_NAME) === GOLD_CARD) {
      cardTypeValue = CARD_TYPES.GOLD;
    }
  }

  return cardTypeValue;
};

export const getCardTypeKeyName = (object, value) => Object.keys(object).find((key) => object[key] === value);

export const getSectionName = (sectionPrefix, amexCardTypes, cardType) => {
  const key = getCardTypeKeyName(amexCardTypes, cardType);
  if (key) return `${sectionPrefix}_${key}`;
  return sectionPrefix;
};

export const isCreditSpecificUrl = ($location) => {
  let eligibleUrl = false;
  const urlPathArr = [RESYCREDIT_GOLD_URL,
    RESYCREDIT_DELTA_RESERVE_URL,
    RESYCREDIT_DELTA_PLATINUM_URL,
    RESYCREDIT_AMEX_PLATINUM_URL];
  const locationPath = $location.path();

  const pathArr = locationPath.split('/');
  if (pathArr.length === 3) {
    if (urlPathArr.includes(locationPath)) {
      eligibleUrl = true;
    }
  }
  return eligibleUrl;
};

export default handleTaggingWithProps;
